import './index.scss'

import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import './i18n';
import '@ant-design/v5-patch-for-react-19'

const root = ReactDOM.createRoot(document.getElementById('roaming-services') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
